import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/service.actions';
import { Col, Row, Form, Modal, Select, Input } from 'antd';
import { dspxGetChildrens } from '../helpers/dspx-utils'
import { ReactComponent as SetServiceIcon } from '../resource/forms/OtherRequests.svg';
import { UNSAVED_DATA_WARNING_TEXT, MODAL_UNSAVED_DATA_WARNING_TITLE } from '../constants/text.constants';

const ServiceForm = Form.create()(
	class extends React.Component {

		render() {
			const { visible, onCancel, onCreate, form, fprops, confirmLoading } = this.props;
			const { getFieldDecorator } = form;

			return (
				<Modal className='dspx-icon-header'
					width={400}
					visible={visible}
					title={<span><SetServiceIcon style={{ height: 50, verticalAlign:'middle', marginRight: 10 }}/> Причина поступления заявки</span>}
					confirmLoading={confirmLoading}
					onCancel={onCancel}
					onOk={onCreate} >
					<Form layout="vertical">
						<Form.Item style={{margin:0,padding:0 }}>
							{getFieldDecorator('request', { initialValue: fprops.request })(
								<Input type='hidden' />)}
						</Form.Item>

						<Row gutter={16}>
							<Col span={24}>
								<div style={{ color: '#17a9f1', fontSize: '13px', fontWeight: '500', marginBottom: '10px' }}>
									{fprops.parentService}
								</div>
								<Form.Item>
									{getFieldDecorator('newServiceId',
										fprops.serviceId ? { initialValue: fprops.serviceId } : { initialValue: undefined })(
											<Select
												showSearch
												placeholder="причина"
												notFoundContent='нет данных'
												optionFilterProp="searchtext" >
												{dspxGetChildrens(fprops.services)}
											</Select>)}
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
			);
		}
	});

class ServiceContainer extends Component {
	state = {
		confirmLoading: false
	};

	handleCancel = () => {
		return new Promise((resolve) => {
			const form = this.formRef && this.formRef.props && this.formRef.props.form;
			const hasTouchedFields = form && typeof form.isFieldsTouched === 'function' ? form.isFieldsTouched() : false;

			if (hasTouchedFields) {
				Modal.confirm({
					title: MODAL_UNSAVED_DATA_WARNING_TITLE,
					content: UNSAVED_DATA_WARNING_TEXT,
					okType: 'danger',
					okText: 'Да',
					cancelText: 'Отмена',
					onOk: () => {
						this.resetAndClose();
						resolve(true);
					},
					onCancel: () => resolve(false),
				});
				return;
			}

			this.resetAndClose();
			resolve(true);
		});
	}

	resetAndClose = () => {
		const form = this.formRef && this.formRef.props && this.formRef.props.form;
		if (form) form.resetFields();
		this.props.dispatch(actions.closeServiceModal());
	}

	handleCreate = () => {
		const form = this.formRef.props.form;

		form.validateFields(async (err, values) => {

			if (err) return

			const s = this.props.services.find(el=>el.id == values.newServiceId)
			if(!s) return
			const v = {...values, newService: s.name}

			if (typeof this.props.updateService === 'function') {
				this.setState({
					confirmLoading: true,
				});

				await this.props.updateService(v);

				this.setState({
					confirmLoading: false,
				});
			} else {
				this.props.dispatch(actions.postService(v));
			}


			form.resetFields();
			this.props.dispatch(actions.closeServiceModal());
		});
	}

	saveFormRef = (formRef) => {

		this.formRef = formRef;
	}

	render() {

		return (
			<ServiceForm
				wrappedComponentRef={this.saveFormRef}
				visible={this.props.serviceModalVisible}
				dispatch={this.props.dispatch}
				onCancel={this.handleCancel}
				onCreate={this.handleCreate}
				fprops={this.props}
				confirmLoading={this.state.confirmLoading}
			/>
		)
	}
}

function mapStateToProps(state) {
	const { serviceStore } = state;

	return serviceStore;
}

export default connect(mapStateToProps)(ServiceContainer);
